import defaultValidationFactory, {
  defaultValidationOptions,
} from '%/utils/validation';

export function addCurrencyDots(value) {
  return value.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

export function addCurrencyFormat(value) {
  const currencyValue = addCurrencyDots(value);
  return `R$ ${currencyValue}`;
}

export function removeCurrencyFormat(value) {
  return value.replace(/R\$ |\./g, '');
}

export function currencyStringToNumber(value) {
  return parseFloat(removeCurrencyFormat(value).replace(',', '.'));
}

export const customValidationFactory = formSelector => {
  const customValidations = {
    ...defaultValidationOptions.customValidations,
    isBirthDateValid(field) {
      if (field.type !== 'date') return false;

      const today = new Date();
      const inputDate = new Date(`${field.value}T00:00:00`);
      const timeDifference = today - inputDate;

      return timeDifference < 0;
    },
  };

  const messages = {
    ...defaultValidationOptions.messages,
    isBirthDateValid: 'Por favor, informe uma data de nascimento válida',
  };

  return defaultValidationFactory(formSelector, {
    ...defaultValidationOptions,
    customValidations,
    messages,
  });
};
